module.exports = __webpack_public_path__ + "static/media/django.1d528e2c.png";